<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="predict-nav-item-upsell"
        data-cy="predict-nav-link"
        class="nav-option"
        :class="{ selected, expanded }"
        :to="{ name: 'BuyPredict' }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <predict-nav-icon />
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components';
import PredictNavIcon from '@/side-nav/components/nav-icons/predict-nav-icon.vue';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    name: 'Predict',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        PredictNavIcon,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.$t('sideNav.Available upgrade: Predict');
        },
        label () {
            return this.$t('sideNav.Predict');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
